// extracted by mini-css-extract-plugin
export default {"container":"animation-for-content_container__Tp6hi","animate":"animation-for-content_animate__ZHMHW"};